/**
 * Created by xuetao.liu on 2018/10/9.
 * @Description global api
 */
export default {
    account:{
        balance:"/bss/app/user/QueryBalanceInfo",                       // 获取账户余额
        chargeList:"/bss/app/noauth/QueryOfferList",                //销售品查询
        queryFlowStatistical:"/bss/dsds/user/QueryFlowDetailDay", //流量统计查询
        queryOrderList:"/bss/app/order/QueryOrderList",                 //查询订单列表
        queryDictionary:"/bss/app/noauth/dictionary/QueryDictionaryValueListInfo",//字典查询
        queryUserOffer:"/bss/app/orderRelation/QueryUserOfferList",     //我的流量列表---用户套餐列表
        // cancelPackage:"/bss/app/orderRelation/UnsubscribePkg",          //退订套餐
        cancelPackage: "/bss/app/order/CancelOrder",                    // 退订套餐
        codeCharge:"/bss/app/topup/TopUpByVoucher",                     //充值码充值
    },
    register: {
        SMS: "/bss/app/noauth/GetVerificationCodeBySMS",                // 获取短信验证码接口
        registerUser: "/bss/app/noauth/RegisterUser",                   // 注册用户接口
        resetPwd_SMS: "/bss/app/noauth/ResetPasswordBySMS",             // 短信重置密码接口
        MAIL: "/bss/app/noauth/SendResetPasswordMail",                  // 发送重置密码邮件接口
        resetPwd_MAIL: "/bss/app/noauth/ResetPasswordByMail",           // 邮件重置密码接口
        active_MAIL: "/bss/app/noauth/SendActivationMail",              // 发送激活邮件接口
        activeUser: "/bss/app/noauth/ActiveUser",                       // 激活账号接口
        checkUser: "/bss/app/noauth/CheckUserCode",                     // 校验用户名称合法性
        checkSMS: "/bss/dsds/noauth/VerifyVerificationCodeFromDSDS",    // 校验短信验证码接口
    },
    interfaces: {
        getCountryInfo: "/api/interfaces/getCountryInfo",               // 获取国家/地区列表接口
        getServiceLists: "/api/interfaces/qalist",                      // 获取列表接口
        getContent: "/api/interfaces/getcontent",                       // 获取内容接口
        getPurchase: "/api/interfaces/getpurchasing",                   // 获取购买数据接口
        about: "/api/frame/web/cms/about?op=getcontent",                //关于
        newslist: "/api/interfaces/newslist",
        newsdetail: "/api/interfaces/newsdetail",                       //新闻详情
        getMvno: "/api/interfaces/getMvnoCode",                         // 获取mvnoCode接口
        getOpenID: "/api/interfaces/getWeChatOpenid",                  // 获取微信openID
        getIp: "/api/interfaces/getIp",                                // 获取IP
        getConfig: "/api/interfaces/get_agreement",
        getCurrencyConfig: "/api/interfaces/getCurrencyConfig",
        filterPackage: "/api/interfaces/get_packages_filter",           // 过滤套餐
        cybersource: "/api/interfaces/cybersource",                     // 接收cybersource平台post过来的data
        partnership: "/api/interfaces/parnership",                      // 合作伙伴提交合作意向信息
        getuDeskSign: "/api/interfaces/getUDeskSignature",              // 获取生成的uDesk客服鉴权字符串
        pushInformation: "/api/interfaces/pushInformation",             // 用户协议和隐私条款增加版本号
        getRecommendDevice: "/api/interfaces/recommendedProducts",      // 获取首页推荐设备
        purchasePoint: "/api/interfaces/purchasePoint",                 // 获取销售点数据接口（新）
        getPoster: "/api/interfaces/productPoster",                     // 获取设备海报接口（新）
        getSEO: "/api/interfaces/seoCanonicalization",                  // 获取seo规范接口（新）
        getCooper: "/api/interfaces/toSeekCooperation",                 // 获取寻求合作列表接口（新）
        getDevice: "/api/interfaces/sku",                               // 获取设备信息
        getStateTax: "/api/interfaces/stateTax",                        // 获取州税
        getDeliveryCompany: "/api/interfaces/deliveryCompany",          // 获取快递公司
        getWarehouses: "/api/interfaces/warehouses",                    // 获取仓库
        viaCMS: "/api/interfaces/viaCMS",                               // cms中转oms
        placeOrder: "/api/interfaces/placeOrder",                       // 创建订单接口
        preCompute: "/api/interfaces/precomputation",                   // 价格预计算接口
        orderEnquiry: "/api/interfaces/orderEnquiry",                   // 再次支付部分参数需要查询的接口
        interLogistics: "/api/interfaces/internationalLogistics",       // 国家物流的接口
    },
    member: {
        login: "/api/member/ajax_login",                                // 登录接口
        userInfo: "/bss/app/user/QueryUserInfo",                        // 获取用户信息
        saleOrderList: '/api/frame/web/order/saleOrderList', // 查询用户售卖订单列表
        saleOrderDetail: '/api/frame/web/order/saleOrderDetail', // 查询用户售卖订单详情
        orderCancel: '/api/frame/web/order/cancel', //取消订单接口
    },
    home:{
        background:"/api/frame/web/cms/index",                          //首页background
        module:"/api/interfaces/indexmodule",                           //content
        links:"/api/interfaces/indexlinks",                             //友情链接
        navList:"/api/interfaces/navlist",                              //导航
        footerInfo:"/api/interfaces/footer_info",                       //底部
        versionInfo:"/api/interfaces/getVersionInfo",                   //底部
        enterpriseList: "/bss/app/noauth/queryEnterpriseConfigList",    // 获取分站配置
        rate: "/bss/app/noauth/QueryCurrencyRateInfo",                  // 获取费率
    },
    data_package: {
        recommend: "/bss/dsds/noauth/QueryRecommendOfferList",          // 获取推荐销售品接口
        rate: "/bss/app/noauth/QueryRateList",                          // 获取费率接口
        getPackage: "/bss/app/noauth/QueryOfferList",                   // 获取套餐销售品接口
        getPayConfig: "/api/interfaces/getpaymentconfig",               // 获取配置支付方式
        getOrderList: "/bss/app/order/QueryOrderList",                  // 订单查询接口
        createOrder: "/bss/app/order/CreateOrder",                      // 创建订单
        balance: "/bss/app/order/DoPayByBalance",                       // 余额支付
        alipay: "/alipay/GetAlipayCredential",                          // 支付宝
        paypal: "/paypal/GetPaypalCredential",                          // paypal
        getPaypalCurr: "/paypal/GetPaypalCurrencyType",                 // 获取paypal支付货币
        weixin: "/weixin/GetWeixinCredential",                          // 微信
        union: "/union/GetUnionCredential",                             // 银联
        cybersource: "/payment/gateway",                                // 信用卡
        queryEnterpriseConfigList:"/bss/app/noauth/queryEnterpriseConfigList",
    },
    modify_information:{
        queryUserInfo:"/bss/app/user/QueryUserInfo",                     //进入界面，获取帐号的相关信息
        updateUserInfo:"/bss/app/user/UpdateUserInfo",                   //编辑提交-身份信息
    },
    equipmentManagement:{
        queryDeviceBindingInfo:"/bss/app/terminal/QueryDeviceBindingInfo",//查询帐号绑定信息
        handleDeviceBinding:"/bss/app/terminal/HandleDeviceBinding"       //提交---绑定或解除绑定IMEI
    },
    modifyPassword:{
        userLogout:"/bss/app/user/UserLogout",                            //退出登录
        updatePassword:"/bss/app/user/UpdatePassword"                     //修改密码
    },
    common: {
        sendEmail: "/bss/ucp/ucpsend/email/sendEmail",                    // 发送邮件
    },
    mps: {
        queryOrgCode: "/webmps/user/device/queryOrgCode"                       // 检测IMEI是否归属阿联酋
    },
    oms: {
        queryCouponCode: "/api/thirdInfo/thirdPartyQueryCoupon",                // 查询oms优惠码接口
        queryOrderSale: "/api/sale/queryOrderSale",                             // 查询oms订单接口
    },
    us_mall: {
        queryProductList: "/api/frame/web/sku/deviceList",                      // 查询产品列表
        queryDeviceContent: "/api/frame/web/sku/graphicContent",                // 查询设备详情的图文信息
        addCart: "/api/frame/web/cart/add",                                     // 添加到购物车
        queryCart: "/api/frame/web/cart/userCartList",                          // 查询用户的购物车数据
        removeCart: "/api/frame/web/cart/remove",                               // remove单条购物车数据
        syncData: "/api/frame/web/cart/sync",                                   // 同步购物车数据
        cancelOrReturn:"/api/frame/web/order/cancel",                           //订单取消、退款、退货接口
        getCMS: "/api/frame/web/cms/index",
        getCoop: "/api/frame/web/cms/about?op=toSeekCooperation",
        getSupport: "/api/frame/web/cms/support",
        placeSaleOrder: "/api/frame/web/order/placeSaleOrder",                  //售卖产品下单接口
        getWXAuthUrl: "/api/frame/web/weixin/authCodeUrl",                      //获取微信授权url
        bindOpenid: "/api/frame/web/weixin/bindOpenid",                         //微信openid与用户信息绑定
        saleOrderDetail: "/api/frame/web/order/saleOrderDetail",                //订单详情
        upDateCart: "/api/frame/web/cart/update",                               //更新购物城商品数量
        productPoster:"/api/frame/web/cms/cloudsim",                            //产品详情海报
        verify: "/api/frame/web/coupon/verify",                                 //优惠券使用验证
        calculateOrderAmount: "/api/frame/web/order/calculateOrderAmount",      //计算下单金额
    }
}



// WEBPACK FOOTER //
// ./src/libs/api.js